// Zentrales Case-Study-Register. Neue Case Study: Datei in ./posts anlegen
// und hier importieren — kein neuer Routen- oder Listing-Eintrag nötig.
import handwerk from './posts/handwerk';
import taxLaw from './posts/tax-law';

// Neueste zuerst
export const caseStudies = [handwerk, taxLaw].sort(
  (a, b) => new Date(b.date) - new Date(a.date)
);

export const branches = ['Gesundheit', 'Steuern', 'Handwerk', 'Bildung'];

export const getCaseStudyBySlug = (slug) =>
  caseStudies.find((post) => post.slug === slug);

/** Empfehlungen: explizit verlinkte Case Studies, aufgefüllt mit den neuesten anderen. */
export const getRelatedCaseStudies = (post, count = 2) => {
  const explicit = (post.related || [])
    .map((slug) => getCaseStudyBySlug(slug))
    .filter(Boolean);
  const fillers = caseStudies.filter(
    (p) => p.slug !== post.slug && !explicit.some((e) => e.slug === p.slug)
  );
  return [...explicit, ...fillers].slice(0, count);
};

export const formatCaseStudyDate = (isoDate) =>
  new Date(isoDate).toLocaleDateString('de-DE', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
